import { Constant } from '@configs/index';
import { useCloseRequestList } from '@hooks/Services';
import React from 'react';
import styled from 'styled-components';
import { CreateSearchParams, Error, Loading, ShowNumber } from '../index';

const CloseError = () => {
    const searchParams = CreateSearchParams.Close(Constant.DASHBOARD_SEARCH_CONDITIONS.CLOSE_ERROR);
    const { data, error, loading } = useCloseRequestList.useAllListData(searchParams);
    const totalCount = data?.length || 0;
    return (
        <WrapperWithStyled>
            <LabelWithStyled>不備</LabelWithStyled>
            <Loading loading={loading}/>
            {error && <Error />}
            {!loading && !error &&
                <ShowNumber totalCount={totalCount} />
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    position: relative;
    padding: 0 10px 10px;
    text-align: right;
`
const LabelWithStyled = styled.span`
    font-size: 18px;
    float: left;
    display: inline-block;
    margin-top: 18px;
`

export default CloseError;